import './button.scss';
import classNames from 'classnames';
import ButtonEnum from './ButtonEnum';
import { useTranslation } from 'react-i18next';

interface ButtonProps {
  text?: string;
  icon?: any;
  type: ButtonEnum;
  onClick: () => void;
  className?: string;
  input?: any;
  disabled?: boolean;
  comingSoon?: boolean;
}

const Button = (props: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      className={classNames(
        'custom-button btn',
        props.className,
        { 'btn-primary': props.type === ButtonEnum.PRIMARY },
        { 'btn-danger': props.type === ButtonEnum.DANGER },
        { 'btn-primary-outline': props.type === ButtonEnum.TRANSPARENT },
        { 'btn-notification': props.type === ButtonEnum.NOTIFICATION },
        { 'btn-grey-light': props.type === ButtonEnum.GREY_LIGHT }
      )}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.icon && <span className="button-icon">{props.icon}</span>}
      {props.text}
      {/*<div className="dashboard-action-container">*/}
      {/*  {props.comingSoon && (*/}
      {/*    <div className="button-tag-coming-soon">{t('SOON_TEXT')}</div>*/}
      {/*  )}*/}
      {/*</div>*/}
    </button>
  );
};
export default Button;
